export const data = [
    {
        title: 'Alabama',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Alaska',
        manufactures: 5,
        distributors: 111,
        population: 733391
    },
    {
        title: 'Arizona',
        manufactures: 4,
        distributors: 123,
        population: 7151502
    },
    {
        title: 'Arkansas',
        manufactures: 4,
        distributors: 123,
        population: 3011524
    },
    {
        title: 'California',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Colorado',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Connecticut',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Delaware',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Florida',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Georgia',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Hawaii',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Alabama',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Alabama',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Alabama',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    },
    {
        title: 'Alabama',
        manufactures: 4,
        distributors: 123,
        population: 5024279
    }
]